<script>
import { required } from "vuelidate/lib/validators";
import MultiSelect from "vue-multiselect";

import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";

export default {
  page: {
    title: "Gateway",
  },
  emits: ["submitted", "cancelSubmit"],
  props: {
    currentProps: Object,
  },
  data() {
    return {
      hotels: [],
      gateway_form: {
        hotel: null,
        mac_address: null,
        ip_address: null,
        name: null,
        model: null,
        firmware_version: null,
      },
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
    };
  },
  components: {
    MultiSelect,
  },
  validations: {
    gateway_form: {
      mac_address: { required },
      name: { required },
      // ip_address: { required },
      firmware_version: { required },
    },
  },
  mounted() {
    this.setValue();
    this.getHotels();
  },
  methods: {
    // Method is used to get list of all hotels
    async getHotels() {
      try {
        const response = await UserService.getHotelsList();
        if (response) {
          response.results.map((item) => {
            this.hotels.push({ text: item.name, value: item.id });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to handle set value
    setValue() {
      if (this.currentProps.isEdit) {
        if (this.currentProps.gateway.hotel !== null) {
          this.gateway_form.hotel = {
            value: this.currentProps.gateway.hotel.id,
            text: this.currentProps.gateway.hotel.name,
          };
        }
        this.gateway_form.mac_address = this.currentProps.gateway.mac_address;
        this.gateway_form.ip_address = this.currentProps.gateway.ip_address;
        this.gateway_form.name = this.currentProps.gateway.name;
        this.gateway_form.firmware_version =
          this.currentProps.gateway.firmware_version;
      }
    },
    // Method is used to add and update gateway data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.gateway_form.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.currentProps.isEdit == false) {
          UserService.addGateway(this.gateway_form)
            .then((response) => {
              this.isBtnLoading = false;
              this.submitted = false;
              this.$emit("submitted", { data: response });
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.editGateWayData(
            this.currentProps.gatewayId,
            this.gateway_form
          )
            .then((response) => {
              this.$emit("submitted", { data: response, isEdit: true });
              this.isBtnLoading = false;
              this.submitted = false;
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Update" : "Add New" }} Gateway</h4>
      <hr />
    </div>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="mac_address">
              Mac Address <span class="text-danger">*</span>
            </label>
            <b-form-input
              id="mac_address"
              type="text"
              v-model="gateway_form.mac_address"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.gateway_form.mac_address.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.gateway_form.mac_address.required">
                Mac Address is required.
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="ip_address">IP Address</label>
            <b-form-input
              id="ip_address"
              type="text"
              v-model="gateway_form.ip_address"
              autocomplete="off"
            ></b-form-input>
            <!-- :class="{
                'is-invalid': submitted && $v.gateway_form.ip_address.$error,
              }"
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.gateway_form.ip_address.required">
                IP Address is required.
              </span>
            </div> -->
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="name">Name <span class="text-danger">*</span></label>
            <b-form-input
              id="name"
              type="text"
              v-model="gateway_form.name"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.gateway_form.name.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.gateway_form.name.required">
                Name is required.
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="hotel">Hotel </label>
            <MultiSelect
              v-model="gateway_form.hotel"
              :options="hotels"
              :show-labels="false"
              placeholder="Select Hotel"
              track-by="value"
              label="text"
              name="hotels"
            />
          </div>
        </div>

        <div class="col-sm-6">
          <label for="firmware_version"
            >Firmware Version <span class="text-danger">*</span></label
          >
          <b-form-input
            id="firmware_version"
            type="text"
            v-model="gateway_form.firmware_version"
            autocomplete="off"
            :class="{
              'is-invalid':
                submitted && $v.gateway_form.firmware_version.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.gateway_form.firmware_version.required"
              >Firmware Version is required.</span
            >
          </div>
        </div>
        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              {{ index }}: {{ error[0] }}
            </li>
          </ul>
        </b-alert>
        <div class="col-md-12">
          <hr />
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="$emit('cancelSubmit')"
            >Cancel</b-button
          >

          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="onSubmit"
          >
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
